var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.5h-3v3h3v-3ZM13.5 10.5h-3v3h3v-3ZM10.5 16.5h3v3h-3v-3Z",
    fill: "#4D4D4D"
  })));
};
export { SvgMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTMuNSA0LjVIMTAuNVY3LjVIMTMuNVY0LjVaIiBmaWxsPSIjNEQ0RDREIi8+CjxwYXRoIGQ9Ik0xMy41IDEwLjVIMTAuNVYxMy41SDEzLjVWMTAuNVoiIGZpbGw9IiM0RDRENEQiLz4KPHBhdGggZD0iTTEwLjUgMTYuNUgxMy41VjE5LjVIMTAuNVYxNi41WiIgZmlsbD0iIzRENEQ0RCIvPgo8L3N2Zz4K";